import { expose } from "comlink";
import { env, layer_norm, pipeline } from "@xenova/transformers";

env.cacheDir = `${new URL(import.meta.url).pathname
  .split("/")
  .slice(0, -1)
  .join("/")}/cache`;

const pipePromise =
  navigator.deviceMemory === 8
    ? pipeline("feature-extraction", "nomic-ai/nomic-embed-text-v1.5", {
        quantized: false
      })
    : new Promise((_, reject) => reject());

expose({
  ready: pipePromise.then(() => true).catch(() => false),
  async toVector(text) {
    const pipe = await pipePromise;
    const [array, weights] = splitIfNeeded(`search_query: ${text}`, pipe);
    const embeddings = await pipe(array, { pooling: "mean" });
    const matryoshka_dim = 64;
    const vectors = layer_norm(embeddings, [embeddings.dims[1]])
      .slice(null, [0, matryoshka_dim])
      .normalize(2, -1)
      .tolist();

    return vectors.length === 1
      ? vectors[0]
      : weightedAverageVector(vectors, weights);
  }
});

function splitIfNeeded(text, pipe) {
  const array = [];
  const weights = [];

  for (
    let tokens = pipe.tokenizer.encode(text),
      maxTokens = pipe.model.config.n_positions - 10,
      chunk,
      i = 0,
      j = tokens.length;
    i < j;
    i += maxTokens
  ) {
    chunk = tokens.slice(i, i + maxTokens);

    weights.push(chunk.length / j);
    array.push(pipe.tokenizer.decode(chunk));
  }

  return [array, weights];
}
function weightedAverageVector(vectors, weights) {
  const vectorDimension = vectors[0].length;
  const weightedAverages = new Array(vectorDimension).fill(0);

  for (let i = 0, j = vectors.length; i < j; i++) {
    for (
      let vector = vectors[i], weight = weights[i], k = 0;
      k < vectorDimension;
      k++
    ) {
      weightedAverages[k] += vector[k] * weight;
    }
  }

  return weightedAverages;
}
